<template>
  <router-view />
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useThemeStore } from '@/stores/theme';

const theme = useThemeStore();
onMounted(() => theme.initialize());
</script>
